/**
 * Baut die Optionen für einen Bestätigungsdialog zum Löschen.
 * @param title die Bezeichnung des Objekts mit Artikel, sodass der "Satz Sind Sie sicher, dass Sie ${title} löschen möchten?" Sinn ergibt
 * @param onSubmit
 * @param onClose Wenn onClose nicht übergeben wird, werden standardmäßig Abbrechen-Schaltflächen dargestellt,
 * die den Bestätigungsdialog einfach schließen.
 * @returns {{onClose: onClose, onSubmit: *, description: string, title: string}}
 */
export const confirmDeleteOption = (title, onSubmit, onClose = () => {}) => {
    return {
        title: "Löschen bestätigen",
        description: `Sind Sie sicher, dass Sie ${title} löschen möchten?`,
        onSubmit,
        onClose,
    };
};
